<template>
  <AuthCard>
    <div class="text-center">
      <p class="fs-5 mb-4" data-test="success-message">
        Your password is now changed.
      </p>
      <router-link :to="{name: 'signin'}" data-test="signin-link">
        Sign in <span aria-hidden="true">&rarr;</span>
      </router-link>
    </div>
  </AuthCard>
</template>

<script setup>
import AuthCard from './components/AuthCard.vue';
</script>
